// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header nav {
  background-color: var(--main-header-color);
  padding: 10px;
}
header nav .nav-link {
  margin-right: 12px;
}
header nav .lsn-nav-link-branded {
  font-size: var(--main-font-size-links);
}
header nav div.headerLogo:last-child {
  justify-content: center !important;
}
header nav .headerLinks[hidden] {
  display: none;
}
header nav #dropdown-basic {
  border: none !important;
}
header nav #dropdown-basic:focus {
  box-shadow: 0 0 0 2px var(--main-primary-color);
}
header nav .dropdown-menu {
  display: none;
  inset: 0px auto auto 0px;
  margin: 0px;
  position: absolute;
  top: 100%;
  left: 0 !important;
  width: auto;
  z-index: 1000;
  float: left;
  padding: 0;
  margin: 0.125rem 0 0;
  font-size: var(--main-font-size-primary);
  text-align: left;
  list-style: none;
  background-color: var(--main-white);
  background-clip: padding-box;
  box-shadow: 0 0.4rem 1rem color-mix(in srgb, var(--main-black), var(--main-white));
  border-radius: var(--main-control-border-radius);
  transform: none;
}
header nav .dropdown-menu a:focus {
  box-shadow: none;
}
header nav .dropdown.show .dropdown-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
}
header nav .dropdown .show {
  display: block !important;
  position: absolute;
  inset: 0px auto auto 0px;
  margin: 0px;
  transform: translate3d(-61px, 34px, 0px);
  z-index: 100;
}
header nav .dropdown-item {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem 0.5rem 1rem !important;
  clear: both;
  font-weight: 400;
  color: var(--main-primary-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
header nav .btn.btn-primary {
  background: none;
  border: none;
  color: var(--main-primary-color);
}
header nav .btn.btn-primary:focus,
header nav .btn.btn-primary:hover {
  background: none;
  color: var(--main-primary-color);
}
header nav .login-header-link {
  font-size: var(--main-font-size-links);
}
header nav .login-header-nav {
  margin: 1.8rem 0 1.8rem 1.8rem;
}
header nav .lsn-logo-img {
  margin: auto;
}
header nav .lsn-user-branded {
  font-weight: bolder;
  font-size: var(--main-font-size-links);
}
.navbar-section {
  display: flex;
  justify-content: center !important;
}
.navbar-section-with-links {
  display: flex;
  justify-content: space-between !important;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/layout/Header.less"],"names":[],"mappings":"AAAA;EACE,0CAAA;EACA,aAAA;AACF;AAHA;EAKI,kBAAA;AACJ;AANA;EASI,sCAAA;AAAJ;AATA;EAaI,kCAAA;AADJ;AAZA;EAiBI,aAAA;AAFJ;AAfA;EAsBI,uBAAA;AAJJ;AAMI;EACE,+CAAA;AAJN;AArBA;EA8BI,aAAA;EAEA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,wCAAA;EACA,gBAAA;EACA,gBAAA;EACA,mCAAA;EACA,4BAAA;EACA,kFAAA;EACA,gDAAA;EACA,eAAA;AAPJ;AA1CA;EAoDM,gBAAA;AAPN;AA7CA;EAyDI,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;AATJ;AArDA;EAkEI,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,wCAAA;EACA,YAAA;AAVJ;AA7DA;EA2EI,cAAA;EACA,WAAA;EACA,2CAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;AAXJ;AAzEA;EAwFI,gBAAA;EACA,YAAA;EACA,gCAAA;AAZJ;AA9EA;;EA+FI,gBAAA;EACA,gCAAA;AAbJ;AAnFA;EAoGI,sCAAA;AAdJ;AAtFA;EAwGI,8BAAA;AAfJ;AAzFA;EA4GI,YAAA;AAhBJ;AA5FA;EAgHI,mBAAA;EACA,sCAAA;AAjBJ;AAuBE;EACE,aAAA;EACA,kCAAA;AArBJ;AAwBE;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;AAtBJ","sourcesContent":["header nav {\n  background-color: var(--main-header-color);\n  padding: 10px;\n\n  .nav-link {\n    margin-right: 12px;\n  }\n\n  .lsn-nav-link-branded {\n    font-size: var(--main-font-size-links);\n  }\n\n  div.headerLogo:last-child {\n    justify-content: center !important;\n  }\n\n  .headerLinks[hidden] {\n    display: none;\n  }\n\n\n  #dropdown-basic {\n    border: none !important;\n\n    &:focus {\n      box-shadow: 0 0 0 2px var(--main-primary-color);\n    }\n  }\n\n  .dropdown-menu {\n    display: none;\n    position: absolute;\n    inset: 0px auto auto 0px;\n    margin: 0px;\n    position: absolute;\n    top: 100%;\n    left: 0 !important;\n    width: auto;\n    z-index: 1000;\n    float: left;\n    padding: 0;\n    margin: .125rem 0 0;\n    font-size: var(--main-font-size-primary);\n    text-align: left;\n    list-style: none;\n    background-color: var(--main-white);\n    background-clip: padding-box;\n    box-shadow: 0 0.4rem 1rem color-mix(in srgb, var(--main-black), var(--main-white));\n    border-radius: var(--main-control-border-radius);\n    transform: none;\n\n    a:focus {\n      box-shadow: none;\n    }\n  }\n\n  .dropdown.show .dropdown-backdrop {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 9;\n  }\n\n  .dropdown .show {\n    display: block !important;\n    position: absolute;\n    inset: 0px auto auto 0px;\n    margin: 0px;\n    transform: translate3d(-61px, 34px, 0px);\n    z-index: 100;\n  }\n\n  .dropdown-item {\n    display: block;\n    width: 100%;\n    padding: .5rem 1rem .5rem 1rem !important;\n    clear: both;\n    font-weight: 400;\n    color: var(--main-primary-color);\n    text-align: inherit;\n    white-space: nowrap;\n    background-color: transparent;\n    border: 0;\n  }\n\n  .btn.btn-primary {\n    background: none;\n    border: none;\n    color: var(--main-primary-color);\n  }\n\n  .btn.btn-primary:focus,\n  .btn.btn-primary:hover {\n    background: none;\n    color: var(--main-primary-color);\n  }\n\n  .login-header-link {\n    font-size: var(--main-font-size-links);\n  }\n\n  .login-header-nav {\n    margin: 1.8rem 0 1.8rem 1.8rem;\n  }\n\n  .lsn-logo-img {\n    margin: auto;\n  }\n\n  .lsn-user-branded {\n    font-weight: bolder;\n    font-size: var(--main-font-size-links);\n  }\n\n}\n\n.navbar {\n  &-section {\n    display: flex;\n    justify-content: center !important;\n  }\n\n  &-section-with-links {\n    display: flex;\n    justify-content: space-between !important;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
